import React, { useEffect, useState } from "react";
import { FaSun, FaMoon } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./About.css"

const About = () => {
  const navigate = useNavigate()
  const [darkMode, setDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme === 'dark' ||
      (!savedTheme && window.matchMedia('(prefers-color-scheme: dark)').matches);
  });

  // Apply dark/light mode
  useEffect(() => {
    if (darkMode) {
      document.documentElement.setAttribute('data-theme', 'dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.setAttribute('data-theme', 'light');
      localStorage.setItem('theme', 'light');
    }
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode(prevMode => !prevMode);
  };

  return (
    <>
      <header className="top-header">
        <div className="header-left">
          <div className="date-time">
            <span className="date">{new Date().toLocaleDateString('ta-IN')}</span>
            <span className="time">{new Date().toLocaleTimeString('ta-IN', { hour: '2-digit', minute: '2-digit' })}</span>
          </div>
        </div>

        <div className="logo-container">
          <img
            src="/assets/unnamed1.png"
            alt="Lookit"
            className="main-logo"
            onClick={() => {navigate("/")}}
            onError={(e) => {
              e.target.src = "/assets/unnamed1.png";
            }}
            style={{cursor:"pointer"}}
          />
        </div>

        <div className="header-right">
          <button className="theme-toggle" onClick={toggleDarkMode}>
            {darkMode ? <FaSun /> : <FaMoon />}
          </button>
        </div>
      </header>
      <div className="page-container">
        <div className="containerfourabt">
          <div className="page-heroabt">
            <h1>About Lookit</h1>
            <p>Your daily destination for stories, entertainment, sports, and news</p>
          </div>
          <div className="about-contentabt">
            <div className="about-textabt">
              <h2>Our Story</h2>
              <p>Lookit was created to address the modern reader's need for a centralized platform that brings together diverse content from across the web. We recognized the challenge of navigating between multiple sources for daily updates, entertainment news, sports coverage, and compelling stories.</p>

              <p>Our mission is to provide readers with a streamlined experience where they can discover engaging content, stay informed about current events, and explore topics that matter to them—all in one convenient location.</p>

              <h2>What We Offer</h2>
              <p>At Lookit, we curate and organize content from trusted sources across various categories including breaking news, in-depth stories, entertainment updates, and comprehensive sports coverage. Our platform is designed for both casual readers and information enthusiasts who want to stay informed and entertained.</p>

              <h2>Our Values</h2>
              <p>We believe in the power of information to educate, entertain, and connect people. Our content celebrates diverse perspectives, promotes informed discourse, and provides a balanced view of the topics that shape our world. We're committed to quality, credibility, and making information accessible to all.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;